<template>
  <div class="UiCard p-4 rounded-xl border shadow-md bg-white border-gray-200">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UiCard',
}
</script>
